<template>
  <PopUpModal
    ref="popup"
    width="30rem"
    vertical-align="top"
    :allow-viewport-scroll="true"
  >
    <div
      ref="content"
      class="m-3 bb-delete-artefact-dialog-content"
    >
      <div class="row w-50 img-fluid m-auto">
        <img
          :src="image"
          class="img-fluid"
          alt="question mark image"
        />
      </div>
      <div class="row bb-hdg mt-3 mb-1 justify-content-center text-center">
        {{ title }}
      </div>
      <div class="row bb-sub-hdg mt-3 mb-1 justify-content-center text-center">
        {{ message }}
      </div>
      <div
        v-if="subject"
        class="row bb-sub-sub-hdg mt-2 mb-3 justify-content-center text-center"
      >
        {{ subject }}
      </div>
      <div class="d-grid gap-2 mt-3 bb-delete-artefact-dialog-actions">
        <button
          v-if="cancelButton"
          type="button"
          class="btn btn-lg btn-warning"
          @click="_cancel"
        >
          {{ cancelButton }}
        </button>
      </div>
      <hr
        v-if="cancelButton && statuses.length"
        class="bb-delete-artefact-dialog-divider"
      />
      <span class="bb-delete-artefact-dialog-label">Unrecoverable Options</span>
      <div class="d-grid gap-2 bb-delete-artefact-dialog-actions">
        <button
          v-for="status in primaryStatuses"
          :key="status.value"
          type="button"
          class="btn btn-lg btn-primary"
          @click="_confirm(status.value)"
        >
          {{ status.label }}
        </button>
      </div>
      <template v-if="secondaryStatuses.length">
        <hr class="bb-delete-artefact-dialog-divider" />
          <span class="bb-delete-artefact-dialog-label">Recoverable Options</span>
        <div class="d-grid gap-2 bb-delete-artefact-dialog-actions">
          <button
            v-for="status in secondaryStatuses"
            :key="status.value"
            type="button"
            class="btn btn-lg btn-primary"
            @click="_confirm(status.value)"
          >
            {{ status.label }}
          </button>
        </div>
      </template>
    </div>
  </PopUpModal>
</template>

<script>
import PopUpModal from './PopUpModal.vue'
import image from '../assets/images/bbQuestionMark96.png'

export default {
  name: 'DeleteArtefactDialog',
  components: {
    PopUpModal,
  },
  data: () => ({
    title: 'Delete Artefact',
    message: 'Confirm Reason',
    subject: undefined,
    cancelButton: 'Cancel',
    statuses: [],
    resolvePromise: undefined,
    rejectPromise: undefined,
    image,
  }),
  computed: {
    destroyedStatusIndex() {
      return this.statuses.findIndex((status) => status?.value === 'Destroyed')
    },
    primaryStatuses() {
      if (this.destroyedStatusIndex === -1) {
        return this.statuses
      }

      return this.statuses.slice(0, this.destroyedStatusIndex + 1)
    },
    secondaryStatuses() {
      if (this.destroyedStatusIndex === -1) {
        return []
      }

      return this.statuses.slice(this.destroyedStatusIndex + 1)
    },
  },
  methods: {
    show(opts = {}) {
      this.title = opts.title || 'Delete Artefact'
      this.message = opts.message || 'Confirm Reason'
      this.subject = opts.subject
      this.cancelButton = opts.cancelButton || 'Cancel'
      this.statuses = Array.isArray(opts.statuses) ? opts.statuses : []
      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm(status) {
      this.$refs.popup.close()
      this.resolvePromise(status)
    },
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise(null)
    },
  },
}
</script>

<style scoped>
.bb-delete-artefact-dialog-content {
  padding-bottom: 1.5rem;
}

.bb-delete-artefact-dialog-actions {
  padding-bottom: 0.75rem;
}

.bb-delete-artefact-dialog-divider {
  width: 100%;
  height: 0;
  border: 0;
  border-top: 2px solid orange;
  opacity: 1;
  /* border-width: 2px; */
}

.bb-delete-artefact-dialog-label {
  display: block;
  padding-bottom: 1rem;
  font-size: 1.5rem;
  text-align: center;
  color: orange;
}
</style>
